import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import SvgIcon from '@/components/SvgIcon'
import '@/router/guard'   // 引入路由守卫
import './utils/icon.js'  // icon

const app = createApp(App)
app.component('svg-icon', SvgIcon) // 全局注册 SvgIcon 组件
app.use(store).use(router).use(ElementPlus).mount('#app')
